<template>
  <b-card class="border-none">
    <b-input-group class="">
      <b-form-input
        class="border-none shadow-lg"
        type="text"
        min="0.00"
        v-model="search"
        @input="dataLoad"
        placeholder="Enter Search...."
      ></b-form-input>

      <b-input-group-append>
        <b-button
          variant="white"
          class="flex items-center shadow-lg"
          aria-label="search"
          @click="dataLoad()"
        >
          <feather-icon
            class="cursor-pointer mr-2"
            icon="SearchIcon"
            svgClasses="w-4 h-4"
          ></feather-icon>
        </b-button>
      </b-input-group-append>
    </b-input-group>

    <el-table
      class="table-responsive table-flush mt-6"
      header-row-class-name="thead-light table-th-color"
      :data="getAllEpisode.result"
      border
    >
      <el-table-column
        label="Set Banner"
        min-width="80px"
        class-name="text-center"
      >
        <template slot-scope="scope">
          <div class="flex justify-center items-center">
            <el-tooltip class="item" effect="dark" placement="top-start"
              ><template slot="content">
                <span>Set this as Banner</span></template
              >
              <feather-icon
                v-if="!scope.row.isBanner"
                icon="XIcon"
                svgClasses="w-6 text-red-500 cursor-pointer"
                class="ml-2"
                @click="setBanner(scope)"
              ></feather-icon>
              <feather-icon
                v-if="scope.row.isBanner"
                icon="CheckIcon"
                svgClasses="w-6 text-blue-500 cursor-disable"
                class="ml-2"
              ></feather-icon
            ></el-tooltip>
          </div>
        </template>
      </el-table-column>

      <el-table-column
        label="Image"
        prop="image"
        min-width="100px"
        min-height="100px"
      >
        <template slot-scope="scope">
          <img :src="`${$imageURL}/${scope.row.image}`" alt="image" />
        </template>
      </el-table-column>
      <el-table-column
        label="Title"
        min-width="150px"
        prop="title"
        class="ml-12"
      >
        <template v-slot="{ row }">
          <p class="font-semibold text-left name mb-0 text-sm">
            {{ row.title }}
          </p>
        </template>
      </el-table-column>

      <el-table-column
        label="Podcast Ep URL (Add embeded link)"
        prop="link"
        min-width="180px"
      >
        <template v-slot="{ row }">
          <p class="font-semibold text-left name mb-0 text-sm">
            {{ row.link }}
          </p>
        </template>
      </el-table-column>

      <el-table-column label="Description" prop="description" min-width="150px">
        <template v-slot="{ row }">
          <p
            class="font-semibold text-left name mb-0 text-sm ellipsis-3"
            v-html="row.description.slice(0, 80) + '...'"
          ></p>
        </template>
      </el-table-column>

      <el-table-column
        label="Actions"
        min-width="150px"
        class-name="text-center"
      >
        <template slot-scope="scope">
          <div class="flex justify-center items-center">
            <el-tooltip class="item" effect="dark" placement="top-start"
              ><template slot="content">
                <span>Show this as recommended podcast</span></template
              >
              <!-- svgClasses="w-6 text-blue-500 cursor-pointer" -->
              <feather-icon
                v-if="!scope.row.isRecommended"
                icon="StarIcon"
                class="ml-2"
                @click="setRecom(scope, true)"
                :svgClasses="'starInactive'"
              ></feather-icon>
              <!-- svgClasses="w-6 text-blue-500 cursor-pointer" -->
              <feather-icon
                v-if="scope.row.isRecommended"
                icon="StarIcon"
                class="ml-2"
                @click="setRecom(scope, false)"
                :svgClasses="'starActive'"
              ></feather-icon>
            </el-tooltip>
            <feather-icon
              icon="EditIcon"
              svgClasses="w-6 text-blue-500 cursor-pointer"
              class="ml-2"
              @click="handleEdit(scope)"
            ></feather-icon>
            <feather-icon
              icon="Trash2Icon"
              svgClasses="w-6 text-red-600 cursor-pointer"
              class="ml-2"
              @click="handleDelete(scope)"
            ></feather-icon>
          </div>
        </template>
      </el-table-column>
      <!-- <el-table-column
        label="Status"
        min-width="180px"
        class-name="text-center"
      >
        <template slot-scope="scope">
          <div class="flex justify-center items-center">
            <button
              v-if="scope.row.isActive"
              @click="PublishUnPublish(scope, false)"
              class="px-4 py-2 font-semibold bg-primary clr-fff rounded-lg"
            >
              unPublish
            </button>
            <button
              v-if="!scope.row.isActive"
              @click="PublishUnPublish(scope, true)"
              class="px-4 py-2 font-semibold bg-primary clr-fff rounded-lg"
            >
              Publish
            </button>
          </div>
        </template>
      </el-table-column> -->
    </el-table>

    <b-card-footer class="py-4 d-flex justify-content-end">
      <base-pagination
        v-model="currentPage"
        :per-page="perPage"
        :total="totalPages"
        @change="handlePageChange"
      ></base-pagination>
    </b-card-footer>
  </b-card>
</template>
<script>
import { mapState } from "vuex";
import {
  Table,
  TableColumn,
  DropdownMenu,
  DropdownItem,
  Dropdown,
} from "element-ui";
export default {
  name: "light-table",

  components: {
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Dropdown.name]: Dropdown,
    [DropdownItem.name]: DropdownItem,
    [DropdownMenu.name]: DropdownMenu,
  },
  data() {
    return {
      currentPage: 1,
      editModal: false,
      perPage: 5,
      search: "",
      totalPages: 0,
    };
  },
  watch: {
    // search: {
    //   handler: _.debounce(async function (val) {
    //     this.getAll();
    //     this.currentPage = 1;
    //   }, 500),
    // },
  },
  methods: {
    async dataLoad() {
      let curPage = this.currentPage - 1;
      let payload = {
        limit: this.perPage,
        offset: curPage * this.perPage,
        search: this.search,
        podcastId: this.$route.query.pid,
      };

      await this.$store.dispatch("podcast/getall_episode", payload);
      this.totalPages = this.getAllEpisode.totalCount;
    },
    handlePageChange(value) {
      this.currentPage = value;
      this.dataLoad();
    },
    async handleEdit(scope) {
      let { row } = scope;
      this.$router.push({
        name: "edit-podcast-episode",
        query: {
          pid: this.$route.query.pid,
          cid: this.$route.query.cid,
        },
      });
      await this.$store.commit("podcast/SELECTED_EPISODE", row);
    },
    async setRecom(scope, val) {
      let { row } = scope;
      let payload = {
        episodeId: row._id,
        isRecommended: val,
      };
      const editData = await this.$store.dispatch(
        "podcast/update_episode",
        payload
      );
      this.dataLoad();
      if (val) {
        return this.$swal({
          html: `<p class="text-center">Podcast set for recommendation!</p>`,
          icon: "success",
          confirmButtonColor: "#830c81",
        });
      } else {
        return this.$swal({
          html: `<p class="text-center">Podcast Removed from recommendation!</p>`,
          icon: "success",
          confirmButtonColor: "#830c81",
        });
      }
    },
    async PublishUnPublish(scope, val) {
      let { row } = scope;
      let payload = {
        episodeId: row._id,
        isActive: val,
      };
      await this.$store.dispatch("podcast/update_episode", payload);
      this.dataLoad();
      // return this.$swal({
      //   html: `<p class="text-center">Episode set for recommendation!</p>`,
      //   icon: "success",
      //   confirmButtonColor: "#830c81",
      // });
    },
    async setBanner(scope) {
      let { row } = scope;
      let payload = {
        episodeId: row._id,
        isBanner: true,
      };
      const editData = await this.$store.dispatch(
        "podcast/update_episode",
        payload
      );
      this.dataLoad();
      return this.$swal({
        html: `<p class="text-center">Episode set as banner!</p>`,
        icon: "success",
        confirmButtonColor: "#830c81",
      });
    },
    async handleDelete(data) {
      const result = await this.deleteAlert();
      if (result.isConfirmed) {
        this.deleteData(data);
      }
    },
    deleteAlert() {
      return this.$swal({
        title: "Are you sure?",
        html: `<p class="text-center">You won't be able to revert this!</p>`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#830c81",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, delete it!",
      });
    },
    async deleteData({ row }) {
      const payload = { episodeId: row._id };
      let loader = this.$loading();
      try {
        await this.$store.dispatch("podcast/delete_episode", payload);
        this.dataLoad();
        loader.close();
      } catch (error) {
        loader.close();
      }
    },
  },
  computed: {
    ...mapState("podcast", { getAllEpisode: "getAllEpisode" }),
  },
  mounted() {
    this.dataLoad();
  },
};
</script>
<style>
.starActive {
  fill: #4f0a4b;
  stroke: #4f0a4b;
  cursor: pointer;
}
.starInactive {
  stroke: #4f0a4b;
  cursor: pointer;
}
</style>
